webpackJsonp([35783957827783],{

/***/ 196:
/***/ (function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	  name: true,
	  length: true,
	  prototype: true,
	  caller: true,
	  callee: true,
	  arguments: true,
	  arity: true
	};
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	
	        if (objectPrototype) {
	            var inheritedComponent = getPrototypeOf(sourceComponent);
	            if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	            }
	        }
	
	        var keys = getOwnPropertyNames(sourceComponent);
	
	        if (getOwnPropertySymbols) {
	            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                try { // Avoid failures from read-only properties
	                    defineProperty(targetComponent, key, descriptor);
	                } catch (e) {}
	            }
	        }
	
	        return targetComponent;
	    }
	
	    return targetComponent;
	};


/***/ }),

/***/ 96:
/***/ (function(module, exports, __webpack_require__) {

	
	(function() {
	
	  // Baseline setup
	  // --------------
	
	  // Establish the root object, `window` in the browser, or `global` on the server.
	  var root = this;
	
	  // Save the previous value of the `humanize` variable.
	  var previousHumanize = root.humanize;
	
	  var humanize = {};
	
	  if (true) {
	    if (typeof module !== 'undefined' && module.exports) {
	      exports = module.exports = humanize;
	    }
	    exports.humanize = humanize;
	  } else {
	    if (typeof define === 'function' && define.amd) {
	      define('humanize', function() {
	        return humanize;
	      });
	    }
	    root.humanize = humanize;
	  }
	
	  humanize.noConflict = function() {
	    root.humanize = previousHumanize;
	    return this;
	  };
	
	  humanize.pad = function(str, count, padChar, type) {
	    str += '';
	    if (!padChar) {
	      padChar = ' ';
	    } else if (padChar.length > 1) {
	      padChar = padChar.charAt(0);
	    }
	    type = (type === undefined) ? 'left' : 'right';
	
	    if (type === 'right') {
	      while (str.length < count) {
	        str = str + padChar;
	      }
	    } else {
	      // default to left
	      while (str.length < count) {
	        str = padChar + str;
	      }
	    }
	
	    return str;
	  };
	
	  // gets current unix time
	  humanize.time = function() {
	    return new Date().getTime() / 1000;
	  };
	
	  /**
	   * PHP-inspired date
	   */
	
	                        /*  jan  feb  mar  apr  may  jun  jul  aug  sep  oct  nov  dec */
	  var dayTableCommon = [ 0,   0,  31,  59,  90, 120, 151, 181, 212, 243, 273, 304, 334 ];
	  var dayTableLeap   = [ 0,   0,  31,  60,  91, 121, 152, 182, 213, 244, 274, 305, 335 ];
	  // var mtable_common[13] = {  0,  31,  28,  31,  30,  31,  30,  31,  31,  30,  31,  30,  31 };
	  // static int ml_table_leap[13]   = {  0,  31,  29,  31,  30,  31,  30,  31,  31,  30,  31,  30,  31 };
	
	
	  humanize.date = function(format, timestamp) {
	    var jsdate = ((timestamp === undefined) ? new Date() : // Not provided
	                  (timestamp instanceof Date) ? new Date(timestamp) : // JS Date()
	                  new Date(timestamp * 1000) // UNIX timestamp (auto-convert to int)
	                 );
	
	    var formatChr = /\\?([a-z])/gi;
	    var formatChrCb = function (t, s) {
	      return f[t] ? f[t]() : s;
	    };
	
	    var shortDayTxt = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
	    var monthTxt = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
	
	    var f = {
	      /* Day */
	      // Day of month w/leading 0; 01..31
	      d: function () { return humanize.pad(f.j(), 2, '0'); },
	
	      // Shorthand day name; Mon..Sun
	      D: function () { return f.l().slice(0, 3); },
	
	      // Day of month; 1..31
	      j: function () { return jsdate.getDate(); },
	
	      // Full day name; Monday..Sunday
	      l: function () { return shortDayTxt[f.w()]; },
	
	      // ISO-8601 day of week; 1[Mon]..7[Sun]
	      N: function () { return f.w() || 7; },
	
	      // Ordinal suffix for day of month; st, nd, rd, th
	      S: function () {
	        var j = f.j();
	        return j > 4 && j < 21 ? 'th' : {1: 'st', 2: 'nd', 3: 'rd'}[j % 10] || 'th';
	      },
	
	      // Day of week; 0[Sun]..6[Sat]
	      w: function () { return jsdate.getDay(); },
	
	      // Day of year; 0..365
	      z: function () {
	        return (f.L() ? dayTableLeap[f.n()] : dayTableCommon[f.n()]) + f.j() - 1;
	      },
	
	      /* Week */
	      // ISO-8601 week number
	      W: function () {
	        // days between midweek of this week and jan 4
	        // (f.z() - f.N() + 1 + 3.5) - 3
	        var midWeekDaysFromJan4 = f.z() - f.N() + 1.5;
	        // 1 + number of weeks + rounded week
	        return humanize.pad(1 + Math.floor(Math.abs(midWeekDaysFromJan4) / 7) + (midWeekDaysFromJan4 % 7 > 3.5 ? 1 : 0), 2, '0');
	      },
	
	      /* Month */
	      // Full month name; January..December
	      F: function () { return monthTxt[jsdate.getMonth()]; },
	
	      // Month w/leading 0; 01..12
	      m: function () { return humanize.pad(f.n(), 2, '0'); },
	
	      // Shorthand month name; Jan..Dec
	      M: function () { return f.F().slice(0, 3); },
	
	      // Month; 1..12
	      n: function () { return jsdate.getMonth() + 1; },
	
	      // Days in month; 28..31
	      t: function () { return (new Date(f.Y(), f.n(), 0)).getDate(); },
	
	      /* Year */
	      // Is leap year?; 0 or 1
	      L: function () { return new Date(f.Y(), 1, 29).getMonth() === 1 ? 1 : 0; },
	
	      // ISO-8601 year
	      o: function () {
	        var n = f.n();
	        var W = f.W();
	        return f.Y() + (n === 12 && W < 9 ? -1 : n === 1 && W > 9);
	      },
	
	      // Full year; e.g. 1980..2010
	      Y: function () { return jsdate.getFullYear(); },
	
	      // Last two digits of year; 00..99
	      y: function () { return (String(f.Y())).slice(-2); },
	
	      /* Time */
	      // am or pm
	      a: function () { return jsdate.getHours() > 11 ? 'pm' : 'am'; },
	
	      // AM or PM
	      A: function () { return f.a().toUpperCase(); },
	
	      // Swatch Internet time; 000..999
	      B: function () {
	        var unixTime = jsdate.getTime() / 1000;
	        var secondsPassedToday = unixTime % 86400 + 3600; // since it's based off of UTC+1
	        if (secondsPassedToday < 0) { secondsPassedToday += 86400; }
	        var beats = ((secondsPassedToday) / 86.4) % 1000;
	        if (unixTime < 0) {
	          return Math.ceil(beats);
	        }
	        return Math.floor(beats);
	      },
	
	      // 12-Hours; 1..12
	      g: function () { return f.G() % 12 || 12; },
	
	      // 24-Hours; 0..23
	      G: function () { return jsdate.getHours(); },
	
	      // 12-Hours w/leading 0; 01..12
	      h: function () { return humanize.pad(f.g(), 2, '0'); },
	
	      // 24-Hours w/leading 0; 00..23
	      H: function () { return humanize.pad(f.G(), 2, '0'); },
	
	      // Minutes w/leading 0; 00..59
	      i: function () { return humanize.pad(jsdate.getMinutes(), 2, '0'); },
	
	      // Seconds w/leading 0; 00..59
	      s: function () { return humanize.pad(jsdate.getSeconds(), 2, '0'); },
	
	      // Microseconds; 000000-999000
	      u: function () { return humanize.pad(jsdate.getMilliseconds() * 1000, 6, '0'); },
	
	      // Whether or not the date is in daylight savings time
	      /*
	      I: function () {
	        // Compares Jan 1 minus Jan 1 UTC to Jul 1 minus Jul 1 UTC.
	        // If they are not equal, then DST is observed.
	        var Y = f.Y();
	        return 0 + ((new Date(Y, 0) - Date.UTC(Y, 0)) !== (new Date(Y, 6) - Date.UTC(Y, 6)));
	      },
	      */
	
	      // Difference to GMT in hour format; e.g. +0200
	      O: function () {
	        var tzo = jsdate.getTimezoneOffset();
	        var tzoNum = Math.abs(tzo);
	        return (tzo > 0 ? '-' : '+') + humanize.pad(Math.floor(tzoNum / 60) * 100 + tzoNum % 60, 4, '0');
	      },
	
	      // Difference to GMT w/colon; e.g. +02:00
	      P: function () {
	        var O = f.O();
	        return (O.substr(0, 3) + ':' + O.substr(3, 2));
	      },
	
	      // Timezone offset in seconds (-43200..50400)
	      Z: function () { return -jsdate.getTimezoneOffset() * 60; },
	
	      // Full Date/Time, ISO-8601 date
	      c: function () { return 'Y-m-d\\TH:i:sP'.replace(formatChr, formatChrCb); },
	
	      // RFC 2822
	      r: function () { return 'D, d M Y H:i:s O'.replace(formatChr, formatChrCb); },
	
	      // Seconds since UNIX epoch
	      U: function () { return jsdate.getTime() / 1000 || 0; }
	    };    
	
	    return format.replace(formatChr, formatChrCb);
	  };
	
	
	  /**
	   * format number by adding thousands separaters and significant digits while rounding
	   */
	  humanize.numberFormat = function(number, decimals, decPoint, thousandsSep) {
	    decimals = isNaN(decimals) ? 2 : Math.abs(decimals);
	    decPoint = (decPoint === undefined) ? '.' : decPoint;
	    thousandsSep = (thousandsSep === undefined) ? ',' : thousandsSep;
	
	    var sign = number < 0 ? '-' : '';
	    number = Math.abs(+number || 0);
	
	    var intPart = parseInt(number.toFixed(decimals), 10) + '';
	    var j = intPart.length > 3 ? intPart.length % 3 : 0;
	
	    return sign + (j ? intPart.substr(0, j) + thousandsSep : '') + intPart.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + thousandsSep) + (decimals ? decPoint + Math.abs(number - intPart).toFixed(decimals).slice(2) : '');
	  };
	
	
	  /**
	   * For dates that are the current day or within one day, return 'today', 'tomorrow' or 'yesterday', as appropriate.
	   * Otherwise, format the date using the passed in format string.
	   *
	   * Examples (when 'today' is 17 Feb 2007):
	   * 16 Feb 2007 becomes yesterday.
	   * 17 Feb 2007 becomes today.
	   * 18 Feb 2007 becomes tomorrow.
	   * Any other day is formatted according to given argument or the DATE_FORMAT setting if no argument is given.
	   */
	  humanize.naturalDay = function(timestamp, format) {
	    timestamp = (timestamp === undefined) ? humanize.time() : timestamp;
	    format = (format === undefined) ? 'Y-m-d' : format;
	
	    var oneDay = 86400;
	    var d = new Date();
	    var today = (new Date(d.getFullYear(), d.getMonth(), d.getDate())).getTime() / 1000;
	
	    if (timestamp < today && timestamp >= today - oneDay) {
	      return 'yesterday';
	    } else if (timestamp >= today && timestamp < today + oneDay) {
	      return 'today';
	    } else if (timestamp >= today + oneDay && timestamp < today + 2 * oneDay) {
	      return 'tomorrow';
	    }
	
	    return humanize.date(format, timestamp);
	  };
	
	  /**
	   * returns a string representing how many seconds, minutes or hours ago it was or will be in the future
	   * Will always return a relative time, most granular of seconds to least granular of years. See unit tests for more details
	   */
	  humanize.relativeTime = function(timestamp) {
	    timestamp = (timestamp === undefined) ? humanize.time() : timestamp;
	
	    var currTime = humanize.time();
	    var timeDiff = currTime - timestamp;
	
	    // within 2 seconds
	    if (timeDiff < 2 && timeDiff > -2) {
	      return (timeDiff >= 0 ? 'just ' : '') + 'now';
	    }
	
	    // within a minute
	    if (timeDiff < 60 && timeDiff > -60) {
	      return (timeDiff >= 0 ? Math.floor(timeDiff) + ' seconds ago' : 'in ' + Math.floor(-timeDiff) + ' seconds');
	    }
	
	    // within 2 minutes
	    if (timeDiff < 120 && timeDiff > -120) {
	      return (timeDiff >= 0 ? 'about a minute ago' : 'in about a minute');
	    }
	
	    // within an hour
	    if (timeDiff < 3600 && timeDiff > -3600) {
	      return (timeDiff >= 0 ? Math.floor(timeDiff / 60) + ' minutes ago' : 'in ' + Math.floor(-timeDiff / 60) + ' minutes');
	    }
	
	    // within 2 hours
	    if (timeDiff < 7200 && timeDiff > -7200) {
	      return (timeDiff >= 0 ? 'about an hour ago' : 'in about an hour');
	    }
	
	    // within 24 hours
	    if (timeDiff < 86400 && timeDiff > -86400) {
	      return (timeDiff >= 0 ? Math.floor(timeDiff / 3600) + ' hours ago' : 'in ' + Math.floor(-timeDiff / 3600) + ' hours');
	    }
	
	    // within 2 days
	    var days2 = 2 * 86400;
	    if (timeDiff < days2 && timeDiff > -days2) {
	      return (timeDiff >= 0 ? '1 day ago' : 'in 1 day');
	    }
	
	    // within 29 days
	    var days29 = 29 * 86400;
	    if (timeDiff < days29 && timeDiff > -days29) {
	      return (timeDiff >= 0 ? Math.floor(timeDiff / 86400) + ' days ago' : 'in ' + Math.floor(-timeDiff / 86400) + ' days');
	    }
	
	    // within 60 days
	    var days60 = 60 * 86400;
	    if (timeDiff < days60 && timeDiff > -days60) {
	      return (timeDiff >= 0 ? 'about a month ago' : 'in about a month');
	    }
	
	    var currTimeYears = parseInt(humanize.date('Y', currTime), 10);
	    var timestampYears = parseInt(humanize.date('Y', timestamp), 10);
	    var currTimeMonths = currTimeYears * 12 + parseInt(humanize.date('n', currTime), 10);
	    var timestampMonths = timestampYears * 12 + parseInt(humanize.date('n', timestamp), 10);
	
	    // within a year
	    var monthDiff = currTimeMonths - timestampMonths;
	    if (monthDiff < 12 && monthDiff > -12) {
	      return (monthDiff >= 0 ? monthDiff + ' months ago' : 'in ' + (-monthDiff) + ' months');
	    }
	
	    var yearDiff = currTimeYears - timestampYears;
	    if (yearDiff < 2 && yearDiff > -2) {
	      return (yearDiff >= 0 ? 'a year ago' : 'in a year');
	    }
	
	    return (yearDiff >= 0 ? yearDiff + ' years ago' : 'in ' + (-yearDiff) + ' years');
	  };
	
	  /**
	   * Converts an integer to its ordinal as a string.
	   *
	   * 1 becomes 1st
	   * 2 becomes 2nd
	   * 3 becomes 3rd etc
	   */
	  humanize.ordinal = function(number) {
	    number = parseInt(number, 10);
	    number = isNaN(number) ? 0 : number;
	    var sign = number < 0 ? '-' : '';
	    number = Math.abs(number);
	    var tens = number % 100;
	
	    return sign + number + (tens > 4 && tens < 21 ? 'th' : {1: 'st', 2: 'nd', 3: 'rd'}[number % 10] || 'th');
	  };
	
	  /**
	   * Formats the value like a 'human-readable' file size (i.e. '13 KB', '4.1 MB', '102 bytes', etc).
	   *
	   * For example:
	   * If value is 123456789, the output would be 117.7 MB.
	   */
	  humanize.filesize = function(filesize, kilo, decimals, decPoint, thousandsSep, suffixSep) {
	    kilo = (kilo === undefined) ? 1024 : kilo;
	    if (filesize <= 0) { return '0 bytes'; }
	    if (filesize < kilo && decimals === undefined) { decimals = 0; }
	    if (suffixSep === undefined) { suffixSep = ' '; }
	    return humanize.intword(filesize, ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB'], kilo, decimals, decPoint, thousandsSep, suffixSep);
	  };
	
	  /**
	   * Formats the value like a 'human-readable' number (i.e. '13 K', '4.1 M', '102', etc).
	   *
	   * For example:
	   * If value is 123456789, the output would be 117.7 M.
	   */
	  humanize.intword = function(number, units, kilo, decimals, decPoint, thousandsSep, suffixSep) {
	    var humanized, unit;
	
	    units = units || ['', 'K', 'M', 'B', 'T'],
	    unit = units.length - 1,
	    kilo = kilo || 1000,
	    decimals = isNaN(decimals) ? 2 : Math.abs(decimals),
	    decPoint = decPoint || '.',
	    thousandsSep = thousandsSep || ',',
	    suffixSep = suffixSep || '';
	
	    for (var i=0; i < units.length; i++) {
	      if (number < Math.pow(kilo, i+1)) {
	        unit = i;
	        break;
	      }
	    }
	    humanized = number / Math.pow(kilo, unit);
	
	    var suffix = units[unit] ? suffixSep + units[unit] : '';
	    return humanize.numberFormat(humanized, decimals, decPoint, thousandsSep) + suffix;
	  };
	
	  /**
	   * Replaces line breaks in plain text with appropriate HTML
	   * A single newline becomes an HTML line break (<br />) and a new line followed by a blank line becomes a paragraph break (</p>).
	   * 
	   * For example:
	   * If value is Joel\nis a\n\nslug, the output will be <p>Joel<br />is a</p><p>slug</p>
	   */
	  humanize.linebreaks = function(str) {
	    // remove beginning and ending newlines
	    str = str.replace(/^([\n|\r]*)/, '');
	    str = str.replace(/([\n|\r]*)$/, '');
	
	    // normalize all to \n
	    str = str.replace(/(\r\n|\n|\r)/g, "\n");
	
	    // any consecutive new lines more than 2 gets turned into p tags
	    str = str.replace(/(\n{2,})/g, '</p><p>');
	
	    // any that are singletons get turned into br
	    str = str.replace(/\n/g, '<br />');
	    return '<p>' + str + '</p>';
	  };
	
	  /**
	   * Converts all newlines in a piece of plain text to HTML line breaks (<br />).
	   */
	  humanize.nl2br = function(str) {
	    return str.replace(/(\r\n|\n|\r)/g, '<br />');
	  };
	
	  /**
	   * Truncates a string if it is longer than the specified number of characters.
	   * Truncated strings will end with a translatable ellipsis sequence ('…').
	   */
	  humanize.truncatechars = function(string, length) {
	    if (string.length <= length) { return string; }
	    return string.substr(0, length) + '…';
	  };
	
	  /**
	   * Truncates a string after a certain number of words.
	   * Newlines within the string will be removed.
	   */
	  humanize.truncatewords = function(string, numWords) {
	    var words = string.split(' ');
	    if (words.length < numWords) { return string; }
	    return words.slice(0, numWords).join(' ') + '…';
	  };
	
	}).call(this);


/***/ }),

/***/ 107:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * marked - a markdown parser
	 * Copyright (c) 2011-2014, Christopher Jeffrey. (MIT Licensed)
	 * https://github.com/chjj/marked
	 */
	
	;(function() {
	'use strict';
	
	/**
	 * Block-Level Grammar
	 */
	
	var block = {
	  newline: /^\n+/,
	  code: /^( {4}[^\n]+\n*)+/,
	  fences: noop,
	  hr: /^( *[-*_]){3,} *(?:\n+|$)/,
	  heading: /^ *(#{1,6}) *([^\n]+?) *#* *(?:\n+|$)/,
	  nptable: noop,
	  lheading: /^([^\n]+)\n *(=|-){2,} *(?:\n+|$)/,
	  blockquote: /^( *>[^\n]+(\n(?!def)[^\n]+)*\n*)+/,
	  list: /^( *)(bull) [\s\S]+?(?:hr|def|\n{2,}(?! )(?!\1bull )\n*|\s*$)/,
	  html: /^ *(?:comment *(?:\n|\s*$)|closed *(?:\n{2,}|\s*$)|closing *(?:\n{2,}|\s*$))/,
	  def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +["(]([^\n]+)[")])? *(?:\n+|$)/,
	  table: noop,
	  paragraph: /^((?:[^\n]+\n?(?!hr|heading|lheading|blockquote|tag|def))+)\n*/,
	  text: /^[^\n]+/
	};
	
	block.bullet = /(?:[*+-]|\d+\.)/;
	block.item = /^( *)(bull) [^\n]*(?:\n(?!\1bull )[^\n]*)*/;
	block.item = replace(block.item, 'gm')
	  (/bull/g, block.bullet)
	  ();
	
	block.list = replace(block.list)
	  (/bull/g, block.bullet)
	  ('hr', '\\n+(?=\\1?(?:[-*_] *){3,}(?:\\n+|$))')
	  ('def', '\\n+(?=' + block.def.source + ')')
	  ();
	
	block.blockquote = replace(block.blockquote)
	  ('def', block.def)
	  ();
	
	block._tag = '(?!(?:'
	  + 'a|em|strong|small|s|cite|q|dfn|abbr|data|time|code'
	  + '|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo'
	  + '|span|br|wbr|ins|del|img)\\b)\\w+(?!:/|[^\\w\\s@]*@)\\b';
	
	block.html = replace(block.html)
	  ('comment', /<!--[\s\S]*?-->/)
	  ('closed', /<(tag)[\s\S]+?<\/\1>/)
	  ('closing', /<tag(?:"[^"]*"|'[^']*'|[^'">])*?>/)
	  (/tag/g, block._tag)
	  ();
	
	block.paragraph = replace(block.paragraph)
	  ('hr', block.hr)
	  ('heading', block.heading)
	  ('lheading', block.lheading)
	  ('blockquote', block.blockquote)
	  ('tag', '<' + block._tag)
	  ('def', block.def)
	  ();
	
	/**
	 * Normal Block Grammar
	 */
	
	block.normal = merge({}, block);
	
	/**
	 * GFM Block Grammar
	 */
	
	block.gfm = merge({}, block.normal, {
	  fences: /^ *(`{3,}|~{3,})[ \.]*(\S+)? *\n([\s\S]*?)\s*\1 *(?:\n+|$)/,
	  paragraph: /^/,
	  heading: /^ *(#{1,6}) +([^\n]+?) *#* *(?:\n+|$)/
	});
	
	block.gfm.paragraph = replace(block.paragraph)
	  ('(?!', '(?!'
	    + block.gfm.fences.source.replace('\\1', '\\2') + '|'
	    + block.list.source.replace('\\1', '\\3') + '|')
	  ();
	
	/**
	 * GFM + Tables Block Grammar
	 */
	
	block.tables = merge({}, block.gfm, {
	  nptable: /^ *(\S.*\|.*)\n *([-:]+ *\|[-| :]*)\n((?:.*\|.*(?:\n|$))*)\n*/,
	  table: /^ *\|(.+)\n *\|( *[-:]+[-| :]*)\n((?: *\|.*(?:\n|$))*)\n*/
	});
	
	/**
	 * Block Lexer
	 */
	
	function Lexer(options) {
	  this.tokens = [];
	  this.tokens.links = {};
	  this.options = options || marked.defaults;
	  this.rules = block.normal;
	
	  if (this.options.gfm) {
	    if (this.options.tables) {
	      this.rules = block.tables;
	    } else {
	      this.rules = block.gfm;
	    }
	  }
	}
	
	/**
	 * Expose Block Rules
	 */
	
	Lexer.rules = block;
	
	/**
	 * Static Lex Method
	 */
	
	Lexer.lex = function(src, options) {
	  var lexer = new Lexer(options);
	  return lexer.lex(src);
	};
	
	/**
	 * Preprocessing
	 */
	
	Lexer.prototype.lex = function(src) {
	  src = src
	    .replace(/\r\n|\r/g, '\n')
	    .replace(/\t/g, '    ')
	    .replace(/\u00a0/g, ' ')
	    .replace(/\u2424/g, '\n');
	
	  return this.token(src, true);
	};
	
	/**
	 * Lexing
	 */
	
	Lexer.prototype.token = function(src, top, bq) {
	  var src = src.replace(/^ +$/gm, '')
	    , next
	    , loose
	    , cap
	    , bull
	    , b
	    , item
	    , space
	    , i
	    , l;
	
	  while (src) {
	    // newline
	    if (cap = this.rules.newline.exec(src)) {
	      src = src.substring(cap[0].length);
	      if (cap[0].length > 1) {
	        this.tokens.push({
	          type: 'space'
	        });
	      }
	    }
	
	    // code
	    if (cap = this.rules.code.exec(src)) {
	      src = src.substring(cap[0].length);
	      cap = cap[0].replace(/^ {4}/gm, '');
	      this.tokens.push({
	        type: 'code',
	        text: !this.options.pedantic
	          ? cap.replace(/\n+$/, '')
	          : cap
	      });
	      continue;
	    }
	
	    // fences (gfm)
	    if (cap = this.rules.fences.exec(src)) {
	      src = src.substring(cap[0].length);
	      this.tokens.push({
	        type: 'code',
	        lang: cap[2],
	        text: cap[3] || ''
	      });
	      continue;
	    }
	
	    // heading
	    if (cap = this.rules.heading.exec(src)) {
	      src = src.substring(cap[0].length);
	      this.tokens.push({
	        type: 'heading',
	        depth: cap[1].length,
	        text: cap[2]
	      });
	      continue;
	    }
	
	    // table no leading pipe (gfm)
	    if (top && (cap = this.rules.nptable.exec(src))) {
	      src = src.substring(cap[0].length);
	
	      item = {
	        type: 'table',
	        header: cap[1].replace(/^ *| *\| *$/g, '').split(/ *\| */),
	        align: cap[2].replace(/^ *|\| *$/g, '').split(/ *\| */),
	        cells: cap[3].replace(/\n$/, '').split('\n')
	      };
	
	      for (i = 0; i < item.align.length; i++) {
	        if (/^ *-+: *$/.test(item.align[i])) {
	          item.align[i] = 'right';
	        } else if (/^ *:-+: *$/.test(item.align[i])) {
	          item.align[i] = 'center';
	        } else if (/^ *:-+ *$/.test(item.align[i])) {
	          item.align[i] = 'left';
	        } else {
	          item.align[i] = null;
	        }
	      }
	
	      for (i = 0; i < item.cells.length; i++) {
	        item.cells[i] = item.cells[i].split(/ *\| */);
	      }
	
	      this.tokens.push(item);
	
	      continue;
	    }
	
	    // lheading
	    if (cap = this.rules.lheading.exec(src)) {
	      src = src.substring(cap[0].length);
	      this.tokens.push({
	        type: 'heading',
	        depth: cap[2] === '=' ? 1 : 2,
	        text: cap[1]
	      });
	      continue;
	    }
	
	    // hr
	    if (cap = this.rules.hr.exec(src)) {
	      src = src.substring(cap[0].length);
	      this.tokens.push({
	        type: 'hr'
	      });
	      continue;
	    }
	
	    // blockquote
	    if (cap = this.rules.blockquote.exec(src)) {
	      src = src.substring(cap[0].length);
	
	      this.tokens.push({
	        type: 'blockquote_start'
	      });
	
	      cap = cap[0].replace(/^ *> ?/gm, '');
	
	      // Pass `top` to keep the current
	      // "toplevel" state. This is exactly
	      // how markdown.pl works.
	      this.token(cap, top, true);
	
	      this.tokens.push({
	        type: 'blockquote_end'
	      });
	
	      continue;
	    }
	
	    // list
	    if (cap = this.rules.list.exec(src)) {
	      src = src.substring(cap[0].length);
	      bull = cap[2];
	
	      this.tokens.push({
	        type: 'list_start',
	        ordered: bull.length > 1
	      });
	
	      // Get each top-level item.
	      cap = cap[0].match(this.rules.item);
	
	      next = false;
	      l = cap.length;
	      i = 0;
	
	      for (; i < l; i++) {
	        item = cap[i];
	
	        // Remove the list item's bullet
	        // so it is seen as the next token.
	        space = item.length;
	        item = item.replace(/^ *([*+-]|\d+\.) +/, '');
	
	        // Outdent whatever the
	        // list item contains. Hacky.
	        if (~item.indexOf('\n ')) {
	          space -= item.length;
	          item = !this.options.pedantic
	            ? item.replace(new RegExp('^ {1,' + space + '}', 'gm'), '')
	            : item.replace(/^ {1,4}/gm, '');
	        }
	
	        // Determine whether the next list item belongs here.
	        // Backpedal if it does not belong in this list.
	        if (this.options.smartLists && i !== l - 1) {
	          b = block.bullet.exec(cap[i + 1])[0];
	          if (bull !== b && !(bull.length > 1 && b.length > 1)) {
	            src = cap.slice(i + 1).join('\n') + src;
	            i = l - 1;
	          }
	        }
	
	        // Determine whether item is loose or not.
	        // Use: /(^|\n)(?! )[^\n]+\n\n(?!\s*$)/
	        // for discount behavior.
	        loose = next || /\n\n(?!\s*$)/.test(item);
	        if (i !== l - 1) {
	          next = item.charAt(item.length - 1) === '\n';
	          if (!loose) loose = next;
	        }
	
	        this.tokens.push({
	          type: loose
	            ? 'loose_item_start'
	            : 'list_item_start'
	        });
	
	        // Recurse.
	        this.token(item, false, bq);
	
	        this.tokens.push({
	          type: 'list_item_end'
	        });
	      }
	
	      this.tokens.push({
	        type: 'list_end'
	      });
	
	      continue;
	    }
	
	    // html
	    if (cap = this.rules.html.exec(src)) {
	      src = src.substring(cap[0].length);
	      this.tokens.push({
	        type: this.options.sanitize
	          ? 'paragraph'
	          : 'html',
	        pre: !this.options.sanitizer
	          && (cap[1] === 'pre' || cap[1] === 'script' || cap[1] === 'style'),
	        text: cap[0]
	      });
	      continue;
	    }
	
	    // def
	    if ((!bq && top) && (cap = this.rules.def.exec(src))) {
	      src = src.substring(cap[0].length);
	      this.tokens.links[cap[1].toLowerCase()] = {
	        href: cap[2],
	        title: cap[3]
	      };
	      continue;
	    }
	
	    // table (gfm)
	    if (top && (cap = this.rules.table.exec(src))) {
	      src = src.substring(cap[0].length);
	
	      item = {
	        type: 'table',
	        header: cap[1].replace(/^ *| *\| *$/g, '').split(/ *\| */),
	        align: cap[2].replace(/^ *|\| *$/g, '').split(/ *\| */),
	        cells: cap[3].replace(/(?: *\| *)?\n$/, '').split('\n')
	      };
	
	      for (i = 0; i < item.align.length; i++) {
	        if (/^ *-+: *$/.test(item.align[i])) {
	          item.align[i] = 'right';
	        } else if (/^ *:-+: *$/.test(item.align[i])) {
	          item.align[i] = 'center';
	        } else if (/^ *:-+ *$/.test(item.align[i])) {
	          item.align[i] = 'left';
	        } else {
	          item.align[i] = null;
	        }
	      }
	
	      for (i = 0; i < item.cells.length; i++) {
	        item.cells[i] = item.cells[i]
	          .replace(/^ *\| *| *\| *$/g, '')
	          .split(/ *\| */);
	      }
	
	      this.tokens.push(item);
	
	      continue;
	    }
	
	    // top-level paragraph
	    if (top && (cap = this.rules.paragraph.exec(src))) {
	      src = src.substring(cap[0].length);
	      this.tokens.push({
	        type: 'paragraph',
	        text: cap[1].charAt(cap[1].length - 1) === '\n'
	          ? cap[1].slice(0, -1)
	          : cap[1]
	      });
	      continue;
	    }
	
	    // text
	    if (cap = this.rules.text.exec(src)) {
	      // Top-level should never reach here.
	      src = src.substring(cap[0].length);
	      this.tokens.push({
	        type: 'text',
	        text: cap[0]
	      });
	      continue;
	    }
	
	    if (src) {
	      throw new
	        Error('Infinite loop on byte: ' + src.charCodeAt(0));
	    }
	  }
	
	  return this.tokens;
	};
	
	/**
	 * Inline-Level Grammar
	 */
	
	var inline = {
	  escape: /^\\([\\`*{}\[\]()#+\-.!_>])/,
	  autolink: /^<([^ <>]+(@|:\/)[^ <>]+)>/,
	  url: noop,
	  tag: /^<!--[\s\S]*?-->|^<\/?\w+(?:"[^"]*"|'[^']*'|[^<'">])*?>/,
	  link: /^!?\[(inside)\]\(href\)/,
	  reflink: /^!?\[(inside)\]\s*\[([^\]]*)\]/,
	  nolink: /^!?\[((?:\[[^\]]*\]|[^\[\]])*)\]/,
	  strong: /^__([\s\S]+?)__(?!_)|^\*\*([\s\S]+?)\*\*(?!\*)/,
	  em: /^\b_((?:[^_]|__)+?)_\b|^\*((?:\*\*|[\s\S])+?)\*(?!\*)/,
	  code: /^(`+)([\s\S]*?[^`])\1(?!`)/,
	  br: /^ {2,}\n(?!\s*$)/,
	  del: noop,
	  text: /^[\s\S]+?(?=[\\<!\[_*`]| {2,}\n|$)/
	};
	
	inline._inside = /(?:\[[^\]]*\]|\\[\[\]]|[^\[\]]|\](?=[^\[]*\]))*/;
	inline._href = /\s*<?([\s\S]*?)>?(?:\s+['"]([\s\S]*?)['"])?\s*/;
	
	inline.link = replace(inline.link)
	  ('inside', inline._inside)
	  ('href', inline._href)
	  ();
	
	inline.reflink = replace(inline.reflink)
	  ('inside', inline._inside)
	  ();
	
	/**
	 * Normal Inline Grammar
	 */
	
	inline.normal = merge({}, inline);
	
	/**
	 * Pedantic Inline Grammar
	 */
	
	inline.pedantic = merge({}, inline.normal, {
	  strong: /^__(?=\S)([\s\S]*?\S)__(?!_)|^\*\*(?=\S)([\s\S]*?\S)\*\*(?!\*)/,
	  em: /^_(?=\S)([\s\S]*?\S)_(?!_)|^\*(?=\S)([\s\S]*?\S)\*(?!\*)/
	});
	
	/**
	 * GFM Inline Grammar
	 */
	
	inline.gfm = merge({}, inline.normal, {
	  escape: replace(inline.escape)('])', '~|])')(),
	  url: /^(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/,
	  del: /^~~(?=\S)([\s\S]*?\S)~~/,
	  text: replace(inline.text)
	    (']|', '~]|')
	    ('|', '|https?://|')
	    ()
	});
	
	/**
	 * GFM + Line Breaks Inline Grammar
	 */
	
	inline.breaks = merge({}, inline.gfm, {
	  br: replace(inline.br)('{2,}', '*')(),
	  text: replace(inline.gfm.text)('{2,}', '*')()
	});
	
	/**
	 * Inline Lexer & Compiler
	 */
	
	function InlineLexer(links, options) {
	  this.options = options || marked.defaults;
	  this.links = links;
	  this.rules = inline.normal;
	  this.renderer = this.options.renderer || new Renderer;
	  this.renderer.options = this.options;
	
	  if (!this.links) {
	    throw new
	      Error('Tokens array requires a `links` property.');
	  }
	
	  if (this.options.gfm) {
	    if (this.options.breaks) {
	      this.rules = inline.breaks;
	    } else {
	      this.rules = inline.gfm;
	    }
	  } else if (this.options.pedantic) {
	    this.rules = inline.pedantic;
	  }
	}
	
	/**
	 * Expose Inline Rules
	 */
	
	InlineLexer.rules = inline;
	
	/**
	 * Static Lexing/Compiling Method
	 */
	
	InlineLexer.output = function(src, links, options) {
	  var inline = new InlineLexer(links, options);
	  return inline.output(src);
	};
	
	/**
	 * Lexing/Compiling
	 */
	
	InlineLexer.prototype.output = function(src) {
	  var out = ''
	    , link
	    , text
	    , href
	    , cap;
	
	  while (src) {
	    // escape
	    if (cap = this.rules.escape.exec(src)) {
	      src = src.substring(cap[0].length);
	      out += cap[1];
	      continue;
	    }
	
	    // autolink
	    if (cap = this.rules.autolink.exec(src)) {
	      src = src.substring(cap[0].length);
	      if (cap[2] === '@') {
	        text = escape(
	          cap[1].charAt(6) === ':'
	          ? this.mangle(cap[1].substring(7))
	          : this.mangle(cap[1])
	        );
	        href = this.mangle('mailto:') + text;
	      } else {
	        text = escape(cap[1]);
	        href = text;
	      }
	      out += this.renderer.link(href, null, text);
	      continue;
	    }
	
	    // url (gfm)
	    if (!this.inLink && (cap = this.rules.url.exec(src))) {
	      src = src.substring(cap[0].length);
	      text = escape(cap[1]);
	      href = text;
	      out += this.renderer.link(href, null, text);
	      continue;
	    }
	
	    // tag
	    if (cap = this.rules.tag.exec(src)) {
	      if (!this.inLink && /^<a /i.test(cap[0])) {
	        this.inLink = true;
	      } else if (this.inLink && /^<\/a>/i.test(cap[0])) {
	        this.inLink = false;
	      }
	      src = src.substring(cap[0].length);
	      out += this.options.sanitize
	        ? this.options.sanitizer
	          ? this.options.sanitizer(cap[0])
	          : escape(cap[0])
	        : cap[0]
	      continue;
	    }
	
	    // link
	    if (cap = this.rules.link.exec(src)) {
	      src = src.substring(cap[0].length);
	      this.inLink = true;
	      out += this.outputLink(cap, {
	        href: cap[2],
	        title: cap[3]
	      });
	      this.inLink = false;
	      continue;
	    }
	
	    // reflink, nolink
	    if ((cap = this.rules.reflink.exec(src))
	        || (cap = this.rules.nolink.exec(src))) {
	      src = src.substring(cap[0].length);
	      link = (cap[2] || cap[1]).replace(/\s+/g, ' ');
	      link = this.links[link.toLowerCase()];
	      if (!link || !link.href) {
	        out += cap[0].charAt(0);
	        src = cap[0].substring(1) + src;
	        continue;
	      }
	      this.inLink = true;
	      out += this.outputLink(cap, link);
	      this.inLink = false;
	      continue;
	    }
	
	    // strong
	    if (cap = this.rules.strong.exec(src)) {
	      src = src.substring(cap[0].length);
	      out += this.renderer.strong(this.output(cap[2] || cap[1]));
	      continue;
	    }
	
	    // em
	    if (cap = this.rules.em.exec(src)) {
	      src = src.substring(cap[0].length);
	      out += this.renderer.em(this.output(cap[2] || cap[1]));
	      continue;
	    }
	
	    // code
	    if (cap = this.rules.code.exec(src)) {
	      src = src.substring(cap[0].length);
	      out += this.renderer.codespan(escape(cap[2].trim(), true));
	      continue;
	    }
	
	    // br
	    if (cap = this.rules.br.exec(src)) {
	      src = src.substring(cap[0].length);
	      out += this.renderer.br();
	      continue;
	    }
	
	    // del (gfm)
	    if (cap = this.rules.del.exec(src)) {
	      src = src.substring(cap[0].length);
	      out += this.renderer.del(this.output(cap[1]));
	      continue;
	    }
	
	    // text
	    if (cap = this.rules.text.exec(src)) {
	      src = src.substring(cap[0].length);
	      out += this.renderer.text(escape(this.smartypants(cap[0])));
	      continue;
	    }
	
	    if (src) {
	      throw new
	        Error('Infinite loop on byte: ' + src.charCodeAt(0));
	    }
	  }
	
	  return out;
	};
	
	/**
	 * Compile Link
	 */
	
	InlineLexer.prototype.outputLink = function(cap, link) {
	  var href = escape(link.href)
	    , title = link.title ? escape(link.title) : null;
	
	  return cap[0].charAt(0) !== '!'
	    ? this.renderer.link(href, title, this.output(cap[1]))
	    : this.renderer.image(href, title, escape(cap[1]));
	};
	
	/**
	 * Smartypants Transformations
	 */
	
	InlineLexer.prototype.smartypants = function(text) {
	  if (!this.options.smartypants) return text;
	  return text
	    // em-dashes
	    .replace(/---/g, '\u2014')
	    // en-dashes
	    .replace(/--/g, '\u2013')
	    // opening singles
	    .replace(/(^|[-\u2014/(\[{"\s])'/g, '$1\u2018')
	    // closing singles & apostrophes
	    .replace(/'/g, '\u2019')
	    // opening doubles
	    .replace(/(^|[-\u2014/(\[{\u2018\s])"/g, '$1\u201c')
	    // closing doubles
	    .replace(/"/g, '\u201d')
	    // ellipses
	    .replace(/\.{3}/g, '\u2026');
	};
	
	/**
	 * Mangle Links
	 */
	
	InlineLexer.prototype.mangle = function(text) {
	  if (!this.options.mangle) return text;
	  var out = ''
	    , l = text.length
	    , i = 0
	    , ch;
	
	  for (; i < l; i++) {
	    ch = text.charCodeAt(i);
	    if (Math.random() > 0.5) {
	      ch = 'x' + ch.toString(16);
	    }
	    out += '&#' + ch + ';';
	  }
	
	  return out;
	};
	
	/**
	 * Renderer
	 */
	
	function Renderer(options) {
	  this.options = options || {};
	}
	
	Renderer.prototype.code = function(code, lang, escaped) {
	  if (this.options.highlight) {
	    var out = this.options.highlight(code, lang);
	    if (out != null && out !== code) {
	      escaped = true;
	      code = out;
	    }
	  }
	
	  if (!lang) {
	    return '<pre><code>'
	      + (escaped ? code : escape(code, true))
	      + '\n</code></pre>';
	  }
	
	  return '<pre><code class="'
	    + this.options.langPrefix
	    + escape(lang, true)
	    + '">'
	    + (escaped ? code : escape(code, true))
	    + '\n</code></pre>\n';
	};
	
	Renderer.prototype.blockquote = function(quote) {
	  return '<blockquote>\n' + quote + '</blockquote>\n';
	};
	
	Renderer.prototype.html = function(html) {
	  return html;
	};
	
	Renderer.prototype.heading = function(text, level, raw) {
	  return '<h'
	    + level
	    + ' id="'
	    + this.options.headerPrefix
	    + raw.toLowerCase().replace(/[^\w]+/g, '-')
	    + '">'
	    + text
	    + '</h'
	    + level
	    + '>\n';
	};
	
	Renderer.prototype.hr = function() {
	  return this.options.xhtml ? '<hr/>\n' : '<hr>\n';
	};
	
	Renderer.prototype.list = function(body, ordered) {
	  var type = ordered ? 'ol' : 'ul';
	  return '<' + type + '>\n' + body + '</' + type + '>\n';
	};
	
	Renderer.prototype.listitem = function(text) {
	  return '<li>' + text + '</li>\n';
	};
	
	Renderer.prototype.paragraph = function(text) {
	  return '<p>' + text + '</p>\n';
	};
	
	Renderer.prototype.table = function(header, body) {
	  return '<table>\n'
	    + '<thead>\n'
	    + header
	    + '</thead>\n'
	    + '<tbody>\n'
	    + body
	    + '</tbody>\n'
	    + '</table>\n';
	};
	
	Renderer.prototype.tablerow = function(content) {
	  return '<tr>\n' + content + '</tr>\n';
	};
	
	Renderer.prototype.tablecell = function(content, flags) {
	  var type = flags.header ? 'th' : 'td';
	  var tag = flags.align
	    ? '<' + type + ' style="text-align:' + flags.align + '">'
	    : '<' + type + '>';
	  return tag + content + '</' + type + '>\n';
	};
	
	// span level renderer
	Renderer.prototype.strong = function(text) {
	  return '<strong>' + text + '</strong>';
	};
	
	Renderer.prototype.em = function(text) {
	  return '<em>' + text + '</em>';
	};
	
	Renderer.prototype.codespan = function(text) {
	  return '<code>' + text + '</code>';
	};
	
	Renderer.prototype.br = function() {
	  return this.options.xhtml ? '<br/>' : '<br>';
	};
	
	Renderer.prototype.del = function(text) {
	  return '<del>' + text + '</del>';
	};
	
	Renderer.prototype.link = function(href, title, text) {
	  if (this.options.sanitize) {
	    try {
	      var prot = decodeURIComponent(unescape(href))
	        .replace(/[^\w:]/g, '')
	        .toLowerCase();
	    } catch (e) {
	      return text;
	    }
	    if (prot.indexOf('javascript:') === 0 || prot.indexOf('vbscript:') === 0 || prot.indexOf('data:') === 0) {
	      return text;
	    }
	  }
	  if (this.options.baseUrl && !originIndependentUrl.test(href)) {
	    href = resolveUrl(this.options.baseUrl, href);
	  }
	  var out = '<a href="' + href + '"';
	  if (title) {
	    out += ' title="' + title + '"';
	  }
	  out += '>' + text + '</a>';
	  return out;
	};
	
	Renderer.prototype.image = function(href, title, text) {
	  if (this.options.baseUrl && !originIndependentUrl.test(href)) {
	    href = resolveUrl(this.options.baseUrl, href);
	  }
	  var out = '<img src="' + href + '" alt="' + text + '"';
	  if (title) {
	    out += ' title="' + title + '"';
	  }
	  out += this.options.xhtml ? '/>' : '>';
	  return out;
	};
	
	Renderer.prototype.text = function(text) {
	  return text;
	};
	
	/**
	 * Parsing & Compiling
	 */
	
	function Parser(options) {
	  this.tokens = [];
	  this.token = null;
	  this.options = options || marked.defaults;
	  this.options.renderer = this.options.renderer || new Renderer;
	  this.renderer = this.options.renderer;
	  this.renderer.options = this.options;
	}
	
	/**
	 * Static Parse Method
	 */
	
	Parser.parse = function(src, options, renderer) {
	  var parser = new Parser(options, renderer);
	  return parser.parse(src);
	};
	
	/**
	 * Parse Loop
	 */
	
	Parser.prototype.parse = function(src) {
	  this.inline = new InlineLexer(src.links, this.options, this.renderer);
	  this.tokens = src.reverse();
	
	  var out = '';
	  while (this.next()) {
	    out += this.tok();
	  }
	
	  return out;
	};
	
	/**
	 * Next Token
	 */
	
	Parser.prototype.next = function() {
	  return this.token = this.tokens.pop();
	};
	
	/**
	 * Preview Next Token
	 */
	
	Parser.prototype.peek = function() {
	  return this.tokens[this.tokens.length - 1] || 0;
	};
	
	/**
	 * Parse Text Tokens
	 */
	
	Parser.prototype.parseText = function() {
	  var body = this.token.text;
	
	  while (this.peek().type === 'text') {
	    body += '\n' + this.next().text;
	  }
	
	  return this.inline.output(body);
	};
	
	/**
	 * Parse Current Token
	 */
	
	Parser.prototype.tok = function() {
	  switch (this.token.type) {
	    case 'space': {
	      return '';
	    }
	    case 'hr': {
	      return this.renderer.hr();
	    }
	    case 'heading': {
	      return this.renderer.heading(
	        this.inline.output(this.token.text),
	        this.token.depth,
	        this.token.text);
	    }
	    case 'code': {
	      return this.renderer.code(this.token.text,
	        this.token.lang,
	        this.token.escaped);
	    }
	    case 'table': {
	      var header = ''
	        , body = ''
	        , i
	        , row
	        , cell
	        , flags
	        , j;
	
	      // header
	      cell = '';
	      for (i = 0; i < this.token.header.length; i++) {
	        flags = { header: true, align: this.token.align[i] };
	        cell += this.renderer.tablecell(
	          this.inline.output(this.token.header[i]),
	          { header: true, align: this.token.align[i] }
	        );
	      }
	      header += this.renderer.tablerow(cell);
	
	      for (i = 0; i < this.token.cells.length; i++) {
	        row = this.token.cells[i];
	
	        cell = '';
	        for (j = 0; j < row.length; j++) {
	          cell += this.renderer.tablecell(
	            this.inline.output(row[j]),
	            { header: false, align: this.token.align[j] }
	          );
	        }
	
	        body += this.renderer.tablerow(cell);
	      }
	      return this.renderer.table(header, body);
	    }
	    case 'blockquote_start': {
	      var body = '';
	
	      while (this.next().type !== 'blockquote_end') {
	        body += this.tok();
	      }
	
	      return this.renderer.blockquote(body);
	    }
	    case 'list_start': {
	      var body = ''
	        , ordered = this.token.ordered;
	
	      while (this.next().type !== 'list_end') {
	        body += this.tok();
	      }
	
	      return this.renderer.list(body, ordered);
	    }
	    case 'list_item_start': {
	      var body = '';
	
	      while (this.next().type !== 'list_item_end') {
	        body += this.token.type === 'text'
	          ? this.parseText()
	          : this.tok();
	      }
	
	      return this.renderer.listitem(body);
	    }
	    case 'loose_item_start': {
	      var body = '';
	
	      while (this.next().type !== 'list_item_end') {
	        body += this.tok();
	      }
	
	      return this.renderer.listitem(body);
	    }
	    case 'html': {
	      var html = !this.token.pre && !this.options.pedantic
	        ? this.inline.output(this.token.text)
	        : this.token.text;
	      return this.renderer.html(html);
	    }
	    case 'paragraph': {
	      return this.renderer.paragraph(this.inline.output(this.token.text));
	    }
	    case 'text': {
	      return this.renderer.paragraph(this.parseText());
	    }
	  }
	};
	
	/**
	 * Helpers
	 */
	
	function escape(html, encode) {
	  return html
	    .replace(!encode ? /&(?!#?\w+;)/g : /&/g, '&amp;')
	    .replace(/</g, '&lt;')
	    .replace(/>/g, '&gt;')
	    .replace(/"/g, '&quot;')
	    .replace(/'/g, '&#39;');
	}
	
	function unescape(html) {
		// explicitly match decimal, hex, and named HTML entities
	  return html.replace(/&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/ig, function(_, n) {
	    n = n.toLowerCase();
	    if (n === 'colon') return ':';
	    if (n.charAt(0) === '#') {
	      return n.charAt(1) === 'x'
	        ? String.fromCharCode(parseInt(n.substring(2), 16))
	        : String.fromCharCode(+n.substring(1));
	    }
	    return '';
	  });
	}
	
	function replace(regex, opt) {
	  regex = regex.source;
	  opt = opt || '';
	  return function self(name, val) {
	    if (!name) return new RegExp(regex, opt);
	    val = val.source || val;
	    val = val.replace(/(^|[^\[])\^/g, '$1');
	    regex = regex.replace(name, val);
	    return self;
	  };
	}
	
	function resolveUrl(base, href) {
	  if (!baseUrls[' ' + base]) {
	    // we can ignore everything in base after the last slash of its path component,
	    // but we might need to add _that_
	    // https://tools.ietf.org/html/rfc3986#section-3
	    if (/^[^:]+:\/*[^/]*$/.test(base)) {
	      baseUrls[' ' + base] = base + '/';
	    } else {
	      baseUrls[' ' + base] = base.replace(/[^/]*$/, '');
	    }
	  }
	  base = baseUrls[' ' + base];
	
	  if (href.slice(0, 2) === '//') {
	    return base.replace(/:[\s\S]*/, ':') + href;
	  } else if (href.charAt(0) === '/') {
	    return base.replace(/(:\/*[^/]*)[\s\S]*/, '$1') + href;
	  } else {
	    return base + href;
	  }
	}
	var baseUrls = {};
	var originIndependentUrl = /^$|^[a-z][a-z0-9+.-]*:|^[?#]/i;
	
	function noop() {}
	noop.exec = noop;
	
	function merge(obj) {
	  var i = 1
	    , target
	    , key;
	
	  for (; i < arguments.length; i++) {
	    target = arguments[i];
	    for (key in target) {
	      if (Object.prototype.hasOwnProperty.call(target, key)) {
	        obj[key] = target[key];
	      }
	    }
	  }
	
	  return obj;
	}
	
	
	/**
	 * Marked
	 */
	
	function marked(src, opt, callback) {
	  if (callback || typeof opt === 'function') {
	    if (!callback) {
	      callback = opt;
	      opt = null;
	    }
	
	    opt = merge({}, marked.defaults, opt || {});
	
	    var highlight = opt.highlight
	      , tokens
	      , pending
	      , i = 0;
	
	    try {
	      tokens = Lexer.lex(src, opt)
	    } catch (e) {
	      return callback(e);
	    }
	
	    pending = tokens.length;
	
	    var done = function(err) {
	      if (err) {
	        opt.highlight = highlight;
	        return callback(err);
	      }
	
	      var out;
	
	      try {
	        out = Parser.parse(tokens, opt);
	      } catch (e) {
	        err = e;
	      }
	
	      opt.highlight = highlight;
	
	      return err
	        ? callback(err)
	        : callback(null, out);
	    };
	
	    if (!highlight || highlight.length < 3) {
	      return done();
	    }
	
	    delete opt.highlight;
	
	    if (!pending) return done();
	
	    for (; i < tokens.length; i++) {
	      (function(token) {
	        if (token.type !== 'code') {
	          return --pending || done();
	        }
	        return highlight(token.text, token.lang, function(err, code) {
	          if (err) return done(err);
	          if (code == null || code === token.text) {
	            return --pending || done();
	          }
	          token.text = code;
	          token.escaped = true;
	          --pending || done();
	        });
	      })(tokens[i]);
	    }
	
	    return;
	  }
	  try {
	    if (opt) opt = merge({}, marked.defaults, opt);
	    return Parser.parse(Lexer.lex(src, opt), opt);
	  } catch (e) {
	    e.message += '\nPlease report this to https://github.com/chjj/marked.';
	    if ((opt || marked.defaults).silent) {
	      return '<p>An error occurred:</p><pre>'
	        + escape(e.message + '', true)
	        + '</pre>';
	    }
	    throw e;
	  }
	}
	
	/**
	 * Options
	 */
	
	marked.options =
	marked.setOptions = function(opt) {
	  merge(marked.defaults, opt);
	  return marked;
	};
	
	marked.defaults = {
	  gfm: true,
	  tables: true,
	  breaks: false,
	  pedantic: false,
	  sanitize: false,
	  sanitizer: null,
	  mangle: true,
	  smartLists: false,
	  silent: false,
	  highlight: null,
	  langPrefix: 'lang-',
	  smartypants: false,
	  headerPrefix: '',
	  renderer: new Renderer,
	  xhtml: false,
	  baseUrl: null
	};
	
	/**
	 * Expose
	 */
	
	marked.Parser = Parser;
	marked.parser = Parser.parse;
	
	marked.Renderer = Renderer;
	
	marked.Lexer = Lexer;
	marked.lexer = Lexer.lex;
	
	marked.InlineLexer = InlineLexer;
	marked.inlineLexer = InlineLexer.output;
	
	marked.parse = marked;
	
	if (true) {
	  module.exports = marked;
	} else if (typeof define === 'function' && define.amd) {
	  define(function() { return marked; });
	} else {
	  this.marked = marked;
	}
	
	}).call(function() {
	  return this || (typeof window !== 'undefined' ? window : global);
	}());
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 108:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// resolves . and .. elements in a path array with directory names there
	// must be no slashes, empty elements, or device names (c:\) in the array
	// (so also no leading and trailing slashes - it does not distinguish
	// relative and absolute paths)
	function normalizeArray(parts, allowAboveRoot) {
	  // if the path tries to go above the root, `up` ends up > 0
	  var up = 0;
	  for (var i = parts.length - 1; i >= 0; i--) {
	    var last = parts[i];
	    if (last === '.') {
	      parts.splice(i, 1);
	    } else if (last === '..') {
	      parts.splice(i, 1);
	      up++;
	    } else if (up) {
	      parts.splice(i, 1);
	      up--;
	    }
	  }
	
	  // if the path is allowed to go above the root, restore leading ..s
	  if (allowAboveRoot) {
	    for (; up--; up) {
	      parts.unshift('..');
	    }
	  }
	
	  return parts;
	}
	
	// Split a filename into [root, dir, basename, ext], unix version
	// 'root' is just a slash, or nothing.
	var splitPathRe =
	    /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/;
	var splitPath = function(filename) {
	  return splitPathRe.exec(filename).slice(1);
	};
	
	// path.resolve([from ...], to)
	// posix version
	exports.resolve = function() {
	  var resolvedPath = '',
	      resolvedAbsolute = false;
	
	  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
	    var path = (i >= 0) ? arguments[i] : process.cwd();
	
	    // Skip empty and invalid entries
	    if (typeof path !== 'string') {
	      throw new TypeError('Arguments to path.resolve must be strings');
	    } else if (!path) {
	      continue;
	    }
	
	    resolvedPath = path + '/' + resolvedPath;
	    resolvedAbsolute = path.charAt(0) === '/';
	  }
	
	  // At this point the path should be resolved to a full absolute path, but
	  // handle relative paths to be safe (might happen when process.cwd() fails)
	
	  // Normalize the path
	  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
	    return !!p;
	  }), !resolvedAbsolute).join('/');
	
	  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
	};
	
	// path.normalize(path)
	// posix version
	exports.normalize = function(path) {
	  var isAbsolute = exports.isAbsolute(path),
	      trailingSlash = substr(path, -1) === '/';
	
	  // Normalize the path
	  path = normalizeArray(filter(path.split('/'), function(p) {
	    return !!p;
	  }), !isAbsolute).join('/');
	
	  if (!path && !isAbsolute) {
	    path = '.';
	  }
	  if (path && trailingSlash) {
	    path += '/';
	  }
	
	  return (isAbsolute ? '/' : '') + path;
	};
	
	// posix version
	exports.isAbsolute = function(path) {
	  return path.charAt(0) === '/';
	};
	
	// posix version
	exports.join = function() {
	  var paths = Array.prototype.slice.call(arguments, 0);
	  return exports.normalize(filter(paths, function(p, index) {
	    if (typeof p !== 'string') {
	      throw new TypeError('Arguments to path.join must be strings');
	    }
	    return p;
	  }).join('/'));
	};
	
	
	// path.relative(from, to)
	// posix version
	exports.relative = function(from, to) {
	  from = exports.resolve(from).substr(1);
	  to = exports.resolve(to).substr(1);
	
	  function trim(arr) {
	    var start = 0;
	    for (; start < arr.length; start++) {
	      if (arr[start] !== '') break;
	    }
	
	    var end = arr.length - 1;
	    for (; end >= 0; end--) {
	      if (arr[end] !== '') break;
	    }
	
	    if (start > end) return [];
	    return arr.slice(start, end - start + 1);
	  }
	
	  var fromParts = trim(from.split('/'));
	  var toParts = trim(to.split('/'));
	
	  var length = Math.min(fromParts.length, toParts.length);
	  var samePartsLength = length;
	  for (var i = 0; i < length; i++) {
	    if (fromParts[i] !== toParts[i]) {
	      samePartsLength = i;
	      break;
	    }
	  }
	
	  var outputParts = [];
	  for (var i = samePartsLength; i < fromParts.length; i++) {
	    outputParts.push('..');
	  }
	
	  outputParts = outputParts.concat(toParts.slice(samePartsLength));
	
	  return outputParts.join('/');
	};
	
	exports.sep = '/';
	exports.delimiter = ':';
	
	exports.dirname = function(path) {
	  var result = splitPath(path),
	      root = result[0],
	      dir = result[1];
	
	  if (!root && !dir) {
	    // No dirname whatsoever
	    return '.';
	  }
	
	  if (dir) {
	    // It has a dirname, strip trailing slash
	    dir = dir.substr(0, dir.length - 1);
	  }
	
	  return root + dir;
	};
	
	
	exports.basename = function(path, ext) {
	  var f = splitPath(path)[2];
	  // TODO: make this comparison case-insensitive on windows?
	  if (ext && f.substr(-1 * ext.length) === ext) {
	    f = f.substr(0, f.length - ext.length);
	  }
	  return f;
	};
	
	
	exports.extname = function(path) {
	  return splitPath(path)[3];
	};
	
	function filter (xs, f) {
	    if (xs.filter) return xs.filter(f);
	    var res = [];
	    for (var i = 0; i < xs.length; i++) {
	        if (f(xs[i], i, xs)) res.push(xs[i]);
	    }
	    return res;
	}
	
	// String.prototype.substr - negative index don't work in IE8
	var substr = 'ab'.substr(-1) === 'b'
	    ? function (str, start, len) { return str.substr(start, len) }
	    : function (str, start, len) {
	        if (start < 0) start = str.length + start;
	        return str.substr(start, len);
	    }
	;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(82)))

/***/ }),

/***/ 509:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(123);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _semanticUiReact = __webpack_require__(69);
	
	var _ReleaseParser = __webpack_require__(71);
	
	var _ReleaseParser2 = _interopRequireDefault(_ReleaseParser);
	
	var _getos = __webpack_require__(519);
	
	var _getos2 = _interopRequireDefault(_getos);
	
	var _logo = __webpack_require__(274);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Download = function (_Component) {
	  _inherits(Download, _Component);
	
	  function Download(props, context) {
	    _classCallCheck(this, Download);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	    _this.iconOpt = { size: 'big' };
	    _this.buttonOpt = { size: 'massive', primary: true };
	    _this.voidLinux = _react2.default.createElement(
	      _gatsbyLink2.default,
	      { to: '/releases' },
	      _react2.default.createElement(_semanticUiReact.Icon, _extends({ name: 'linux', disabled: true }, _this.iconOpt))
	    );
	    _this.voidWindows = _react2.default.createElement(
	      _gatsbyLink2.default,
	      { to: '/releases' },
	      _react2.default.createElement(_semanticUiReact.Icon, _extends({ name: 'windows', disabled: true }, _this.iconOpt))
	    );
	    _this.voidMacos = _react2.default.createElement(
	      _gatsbyLink2.default,
	      { to: '/releases' },
	      _react2.default.createElement(_semanticUiReact.Icon, _extends({ name: 'apple', disabled: true }, _this.iconOpt))
	    );
	    _this.linuxLink = _react2.default.createElement(
	      _gatsbyLink2.default,
	      { to: '/releases' },
	      _react2.default.createElement(_semanticUiReact.Icon, _extends({ name: 'linux' }, _this.iconOpt))
	    );
	
	    _this.windowsLink = function (url) {
	      return _react2.default.createElement(
	        'a',
	        { href: url },
	        _react2.default.createElement(_semanticUiReact.Icon, _extends({ name: 'windows' }, _this.iconOpt))
	      );
	    };
	
	    _this.macosLink = function (url) {
	      return _react2.default.createElement(
	        'a',
	        { href: url },
	        _react2.default.createElement(_semanticUiReact.Icon, _extends({ name: 'apple' }, _this.iconOpt))
	      );
	    };
	
	    _this.description = 'Arbore is a free and open-source file sharing application that enables you to send your pictures, documents, files to your contacts privately and without limits.';
	    _this.buttonText = 'Download Arbore';
	    _this.fallback = _react2.default.createElement(
	      _semanticUiReact.Button,
	      _extends({ as: _gatsbyLink2.default, to: '/releases' }, _this.buttonOpt),
	      _this.buttonText
	    );
	
	
	    _this.state = {
	      releases: null
	    };
	    return _this;
	  }
	
	  Download.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    this.context.releases.then(function (releases) {
	      return _this2.setState({ releases: releases });
	    });
	  };
	
	  Download.prototype.render = function render() {
	    var releases = this.state.releases;
	
	    if (!releases) {
	      return _react2.default.createElement(
	        _semanticUiReact.Container,
	        { text: true },
	        _react2.default.createElement(
	          _semanticUiReact.Grid,
	          { columns: 2, stackable: true },
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Column,
	            null,
	            _react2.default.createElement(_semanticUiReact.Image, { src: _logo2.default, size: 'medium' })
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Column,
	            { verticalAlign: 'middle' },
	            _react2.default.createElement(
	              _semanticUiReact.Header,
	              { as: 'h1', style: { fontSize: '4em', fontWeight: 400 }, color: 'blue' },
	              'Arbore'
	            ),
	            _react2.default.createElement(
	              'div',
	              { style: { fontSize: '16px', lineHeight: '24px' } },
	              this.description
	            ),
	            _react2.default.createElement(
	              _semanticUiReact.Segment,
	              { basic: true },
	              _react2.default.createElement(
	                'div',
	                { style: { textAlign: 'center' } },
	                this.fallback
	              ),
	              _react2.default.createElement(
	                'div',
	                { style: { textAlign: 'center' } },
	                '\xA0 \xA0'
	              ),
	              _react2.default.createElement(
	                'div',
	                { style: { textAlign: 'center' } },
	                this.voidWindows,
	                this.voidMacos,
	                this.voidLinux
	              )
	            )
	          )
	        )
	      );
	    }
	
	    var current = releases.current;
	
	    var button = void 0,
	        platform = void 0;
	    switch ((0, _getos2.default)()) {
	      case 'windows':
	        button = current.windowsAssets.length > 0 ? _react2.default.createElement(
	          _semanticUiReact.Button,
	          _extends({ as: 'a', href: current.windowsAssets[0].browserDownloadUrl }, this.buttonOpt),
	          this.buttonText
	        ) : this.fallback;
	        platform = 'Windows';
	        break;
	      case 'osx':
	        button = current.macosAssets.length > 0 ? _react2.default.createElement(
	          _semanticUiReact.Button,
	          _extends({ as: 'a', href: current.macosAssets[0].browserDownloadUrl }, this.buttonOpt),
	          this.buttonText
	        ) : this.fallback;
	        platform = 'MacOS';
	        break;
	      case 'linux':
	        button = this.fallback;
	        platform = 'Linux';
	        break;
	      case 'android':
	        button = this.fallback;
	        platform = 'Android is not supported yet';
	        break;
	      case 'ios':
	        button = this.fallback;
	        platform = 'iOS is not supported yet';
	        break;
	      default:
	        button = this.fallback;
	        break;
	    }
	
	    return _react2.default.createElement(
	      _semanticUiReact.Container,
	      { text: true },
	      _react2.default.createElement(
	        _semanticUiReact.Grid,
	        { columns: 2, stackable: true },
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Column,
	          null,
	          _react2.default.createElement(_semanticUiReact.Image, { src: _logo2.default, size: 'medium' })
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Column,
	          { verticalAlign: 'middle' },
	          _react2.default.createElement(
	            _semanticUiReact.Header,
	            { as: 'h1', style: { fontSize: '4em', fontWeight: 400 }, color: 'blue' },
	            'Arbore'
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: { fontSize: '16px', lineHeight: '24px' } },
	            this.description
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Segment,
	            { basic: true },
	            _react2.default.createElement(
	              'div',
	              { style: { textAlign: 'center' } },
	              button
	            ),
	            _react2.default.createElement(
	              'div',
	              { style: { textAlign: 'center' } },
	              'Version ',
	              current.name,
	              platform ? ' - ' + platform : ''
	            ),
	            _react2.default.createElement(
	              'div',
	              { style: { textAlign: 'center' } },
	              current.windowsAssets.length > 0 ? this.windowsLink(current.windowsAssets[0].browserDownloadUrl) : this.voidWindows,
	              current.macosAssets.length > 0 ? this.macosLink(current.macosAssets[0].browserDownloadUrl) : this.voidMacos,
	              current.linuxAssets.length > 0 ? this.linuxLink : this.voidLinux
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Download;
	}(_react.Component);
	
	exports.default = Download;
	
	
	Download.contextTypes = {
	  releases: _propTypes2.default.object
	};
	module.exports = exports['default'];

/***/ }),

/***/ 1048:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/chat.e4537b22.png";

/***/ }),

/***/ 1049:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/contacts.36727fd0.png";

/***/ }),

/***/ 1050:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/identity.15b8363e.png";

/***/ }),

/***/ 274:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 1051:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/sharing.2069c573.png";

/***/ }),

/***/ 41:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _humanize = __webpack_require__(96);
	
	var _humanize2 = _interopRequireDefault(_humanize);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Asset = function () {
	  function Asset(id, icon, os, browserDownloadUrl, name, size, download_count) {
	    _classCallCheck(this, Asset);
	
	    this.id = id;
	    this.icon = icon;
	    this.os = os;
	    this.browserDownloadUrl = browserDownloadUrl;
	    this.name = name;
	    this.size = size;
	    this.downloadCount = download_count;
	  }
	
	  _createClass(Asset, [{
	    key: 'humanSize',
	    get: function get() {
	      return _humanize2.default.filesize(this.size);
	    }
	  }]);
	
	  return Asset;
	}();
	
	exports.default = Asset;
	module.exports = exports['default'];

/***/ }),

/***/ 70:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Asset = __webpack_require__(41);
	
	var _Asset2 = _interopRequireDefault(_Asset);
	
	var _marked = __webpack_require__(107);
	
	var _marked2 = _interopRequireDefault(_marked);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	_marked2.default.setOptions({
	  gfm: true
	});
	
	var Release = function () {
	  function Release(publishedAt, url, name, body, linuxAssets, windowsAssets, macosAssets) {
	    _classCallCheck(this, Release);
	
	    this.publishedAt = publishedAt;
	    this.url = url;
	    this.name = name;
	    this.body = body;
	    this.linuxAssets = linuxAssets;
	    this.windowsAssets = windowsAssets;
	    this.macosAssets = macosAssets;
	  }
	
	  _createClass(Release, [{
	    key: 'bodyHtml',
	    get: function get() {
	      return { __html: this.body ? (0, _marked2.default)(this.body) : '<span>No changelog available</span>' };
	    }
	  }]);
	
	  return Release;
	}();
	
	exports.default = Release;
	module.exports = exports['default'];

/***/ }),

/***/ 516:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(69);
	
	var _Download = __webpack_require__(509);
	
	var _Download2 = _interopRequireDefault(_Download);
	
	var _identity = __webpack_require__(1050);
	
	var _identity2 = _interopRequireDefault(_identity);
	
	var _contacts = __webpack_require__(1049);
	
	var _contacts2 = _interopRequireDefault(_contacts);
	
	var _sharing = __webpack_require__(1051);
	
	var _sharing2 = _interopRequireDefault(_sharing);
	
	var _chat = __webpack_require__(1048);
	
	var _chat2 = _interopRequireDefault(_chat);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Argument = function Argument(_ref) {
	  var icon = _ref.icon,
	      header = _ref.header,
	      text = _ref.text;
	  return _react2.default.createElement(
	    _semanticUiReact.Grid.Column,
	    null,
	    _react2.default.createElement(
	      _semanticUiReact.Header,
	      null,
	      _react2.default.createElement(_semanticUiReact.Icon, { size: 'huge', name: icon }),
	      header
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: { fontSize: '16px', lineHeight: '24px' } },
	      text
	    )
	  );
	};
	
	var Feature = function Feature(_ref2) {
	  var inverted = _ref2.inverted,
	      image = _ref2.image,
	      header = _ref2.header,
	      text = _ref2.text;
	  return _react2.default.createElement(
	    _semanticUiReact.Segment,
	    { className: 'stripe', vertical: true },
	    _react2.default.createElement(
	      _semanticUiReact.Container,
	      null,
	      _react2.default.createElement(
	        _semanticUiReact.Grid,
	        { columns: 2, stackable: true },
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Row,
	          null,
	          !inverted && _react2.default.createElement(
	            _semanticUiReact.Grid.Column,
	            null,
	            _react2.default.createElement(_semanticUiReact.Image, { src: image })
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Column,
	            { verticalAlign: 'middle' },
	            _react2.default.createElement(
	              _semanticUiReact.Header,
	              { as: 'h3', style: { fontSize: '2em' } },
	              header
	            ),
	            _react2.default.createElement(
	              'p',
	              { style: { fontSize: '1.1em' } },
	              text
	            )
	          ),
	          inverted && _react2.default.createElement(
	            _semanticUiReact.Grid.Column,
	            null,
	            _react2.default.createElement(_semanticUiReact.Image, { src: image })
	          )
	        )
	      )
	    )
	  );
	};
	
	var IndexPage = function IndexPage() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _semanticUiReact.Segment,
	      { basic: true, style: { paddingTop: 0 } },
	      _react2.default.createElement(
	        _semanticUiReact.Container,
	        null,
	        _react2.default.createElement(_semanticUiReact.Message, {
	          icon: 'announcement',
	          header: 'Work in progress',
	          content: 'This software is still being built and is not ready for prime time. In particular, encryption is not here yet. Any feedback and help is welcome !'
	        }),
	        _react2.default.createElement(_semanticUiReact.Message, {
	          icon: 'travel',
	          header: 'Hey by the way',
	          content: _react2.default.createElement(
	            'span',
	            null,
	            'I\'m looking for a cool remote job. Have a look at my\xA0',
	            _react2.default.createElement(
	              'a',
	              { href: 'http://pellelatarte.fr/dl/resume.pdf' },
	              'resume'
	            ),
	            '.'
	          )
	        })
	      )
	    ),
	    _react2.default.createElement(_Download2.default, null),
	    _react2.default.createElement(
	      _semanticUiReact.Segment,
	      { className: 'stripe', vertical: true },
	      _react2.default.createElement(
	        _semanticUiReact.Container,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Grid,
	          { stackable: true },
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Row,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Grid,
	              { columns: 3, divided: true, stackable: true },
	              _react2.default.createElement(Argument, { icon: 'privacy', header: 'Privacy', text: 'Keep your private communications private. Stop being the product, be yourself.' }),
	              _react2.default.createElement(Argument, { icon: 'check', header: 'Share without limits', text: 'No number or size limits. Share as much and anything you want.' }),
	              _react2.default.createElement(Argument, { icon: 'code', header: 'Free & Open Source', text: 'Free as in free beer, Free as in free speech.' })
	            )
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Row,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Grid,
	              { columns: 3, divided: true, stackable: true },
	              _react2.default.createElement(Argument, { icon: 'laptop', header: 'Multi-platform', text: 'Windows, MacOS and Linux are supported.' }),
	              _react2.default.createElement(Argument, { icon: 'bug', header: 'Nasty free', text: 'No spyware, No ads, No user tracking.' }),
	              _react2.default.createElement(Argument, { icon: 'plug', header: 'Decentralized', text: 'Direct transfer from the sender to the recipient. You keep the control.' })
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(Feature, {
	      image: _identity2.default, header: 'Create your identity',
	      text: 'Your identity is simply a name or pseudonym. You can also add an avatar and a biography. You can have as many identity as you want.'
	    }),
	    _react2.default.createElement(Feature, {
	      image: _contacts2.default, header: 'Manage your contacts', inverted: true,
	      text: 'Once you have added your first contact, Arbore will start to suggest new contact you may know so you can easily build your contact list.'
	    }),
	    _react2.default.createElement(Feature, {
	      image: _sharing2.default, header: 'Share',
	      text: 'Share files, documents, pictures ... with your contacts, as you would with an email. The difference is that there is no limits in size, number or type. It also stay private with strong encryption (not available yet).'
	    }),
	    _react2.default.createElement(Feature, {
	      image: _chat2.default, header: 'Chat', inverted: true,
	      text: 'You can also chat with your contacts directly from the application.'
	    })
	  );
	};
	
	exports.default = IndexPage;
	module.exports = exports['default'];

/***/ }),

/***/ 71:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Release = __webpack_require__(70);
	
	var _Release2 = _interopRequireDefault(_Release);
	
	var _Asset = __webpack_require__(41);
	
	var _Asset2 = _interopRequireDefault(_Asset);
	
	var _path = __webpack_require__(108);
	
	var _path2 = _interopRequireDefault(_path);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ReleaseParser = function () {
	  function ReleaseParser(data) {
	    _classCallCheck(this, ReleaseParser);
	
	    this.releases = data.map(ReleaseParser.releaseTransformer);
	  }
	
	  ReleaseParser.releaseTransformer = function releaseTransformer(data) {
	    var linux = [];
	    var windows = [];
	    var macos = [];
	
	    data.assets.forEach(function (asset) {
	      switch (_path2.default.extname(asset.name)) {
	        case '.deb':
	        case '.AppImage':
	        case '.rpm':
	          asset.icon = "linux";asset.os = "Linux";linux.push(asset);break;
	        case '.exe':
	          asset.icon = "windows";asset.os = "Windows";windows.push(asset);break;
	        case '.dmg':
	          asset.icon = "apple";asset.os = "MacOS";macos.push(asset);break;
	        default:
	          throw 'unrecognized';
	      }
	    });
	
	    return new _Release2.default(new Date(Date.parse(data.published_at)), data.url, data.name, data.body, linux.map(ReleaseParser.assetTransformer), windows.map(ReleaseParser.assetTransformer), macos.map(ReleaseParser.assetTransformer));
	  };
	
	  ReleaseParser.assetTransformer = function assetTransformer(data) {
	    return new _Asset2.default(data.id, data.icon, data.os, data.browser_download_url, data.name, data.size, data.download_count);
	  };
	
	  _createClass(ReleaseParser, [{
	    key: 'length',
	    get: function get() {
	      return this.releases.length;
	    }
	  }, {
	    key: 'current',
	    get: function get() {
	      return this.releases[0];
	    }
	  }, {
	    key: 'olds',
	    get: function get() {
	      return this.releases.slice(1);
	    }
	  }, {
	    key: 'linuxDownloads',
	    get: function get() {
	      return this.releases.map(function (release) {
	        return release.linuxAssets.reduce(function (acc, asset) {
	          return acc + asset.downloadCount;
	        }, 0);
	      }).reduce(function (acc, count) {
	        return acc + count;
	      }, 0);
	    }
	  }, {
	    key: 'windowsDownloads',
	    get: function get() {
	      return this.releases.map(function (release) {
	        return release.windowsAssets.reduce(function (acc, asset) {
	          return acc + asset.downloadCount;
	        }, 0);
	      }).reduce(function (acc, count) {
	        return acc + count;
	      }, 0);
	    }
	  }, {
	    key: 'macosDownloads',
	    get: function get() {
	      return this.releases.map(function (release) {
	        return release.macosAssets.reduce(function (acc, asset) {
	          return acc + asset.downloadCount;
	        }, 0);
	      }).reduce(function (acc, count) {
	        return acc + count;
	      }, 0);
	    }
	  }, {
	    key: 'totalDownloads',
	    get: function get() {
	      return this.releases.map(function (release) {
	        return [].concat(release.linuxAssets.reduce(function (acc, asset) {
	          return acc + asset.downloadCount;
	        }, 0), release.windowsAssets.reduce(function (acc, asset) {
	          return acc + asset.downloadCount;
	        }, 0), release.macosAssets.reduce(function (acc, asset) {
	          return acc + asset.downloadCount;
	        }, 0)).reduce(function (acc, count) {
	          return acc + count;
	        }, 0);
	      }).reduce(function (acc, count) {
	        return acc + count;
	      }, 0);
	    }
	  }]);
	
	  return ReleaseParser;
	}();
	
	exports.default = ReleaseParser;
	module.exports = exports['default'];

/***/ }),

/***/ 519:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = getOS;
	function getOS() {
	  var OS = "windows"; //Default
	
	  if (navigator.appVersion.indexOf("Win") !== -1) OS = "windows";
	  if (navigator.appVersion.indexOf("Mac") !== -1) OS = "osx";
	  if (navigator.platform.indexOf("BeOS") !== -1) OS = "beos";
	  if (navigator.platform.indexOf("Linux") !== -1) {
	    if (navigator.userAgent.indexOf("Android") !== -1) OS = "android";else OS = "linux";
	  }
	  if (navigator.platform.indexOf("freebsd") !== -1 || navigator.platform.indexOf("FreeBSD") !== -1) OS = "freebsd";
	  if (navigator.userAgent.indexOf("iPad") !== -1 || navigator.userAgent.indexOf("iPhone") !== -1 || navigator.userAgent.indexOf("iPod") !== -1) OS = "ios";
	
	  return OS;
	}
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-f7f8e937995b424f63a9.js